import { render, staticRenderFns } from "./QuoteRatesMarkups.vue?vue&type=template&id=c452c1fc"
import script from "./QuoteRatesMarkups.vue?vue&type=script&lang=js"
export * from "./QuoteRatesMarkups.vue?vue&type=script&lang=js"
import style0 from "./QuoteRatesMarkups.vue?vue&type=style&index=0&id=c452c1fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports